export enum Flow {
  Onboarding = 'Onboarding',
  MyTrainings = 'MyTrainings'
}
